import React, { useEffect, useState } from "react";

import CustomInput from "../../../../components/common/CustomInput/CustomInput";
import CustomDatePicker from "../../../../components/common/CustomDatePicker/CustomDatePicker";
import CustomRadio from "../../../../components/common/CustomRadio/CustomRadio";
import CustomFileUpload from "../../../../components/common/CustomFileUpload/CustomFileUpload";
import CustomTextArea from "../../../../components/common/CustomTextArea/CustomTextArea";
import BodyHeader from "../../../../components/common/CommonBodyHeader";
import CustomDropdown from "../../../../components/common/CustomDropdown/CustomDropdown";

import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { addHelperMasterAsync } from "../../../../redux/features/helperMaster";
import {
   fetchAllContractorsAsync,
   fetchAllFleetAsync,
} from "../../../../redux/features/driverMaster";
import { backdropLoadingAction } from "../../../../redux/features/helperSlice";

import { useFormik } from "formik";
import * as Yup from "yup";
import moment from "moment";
import toast from "react-hot-toast";
import validation from "../../../../helpers/validation";
import useFocusErrorField from "../../../../Hooks/useFocusErrorField";

const validationSchema = Yup.object().shape({
   //vehicle_no: Yup.string().required("Vehicle Number is required"),
   name: Yup.string()
      .required("Please provide a name")
      .min(3, "Name must be at least 3 characters")
      .max(50, "Name cannot exceed 50 characters"),
   mobile: Yup.string()
      .matches(/^\d{10}$/, "Mobile number must be 10 digits")
      .required("Mobile number is required"),
   dob: Yup.string()
      .required("DOB is required")
      .test("is-past", "Date must be in the past", function (value) {
         // Parse the date string using Moment.js and check if it's before 31-12-2999
         const date = moment(value, "YYYY-MM-DD");
         return date.isValid() && date.isBefore(moment(), "years");
      })
      .test("is-before-2999", "Date must be before 31-12-2999", function (value) {
         // Parse the date string using Moment.js and check if it's in the past
         const date = moment(value, "YYYY-MM-DD");
         return date.isValid() && date.isBefore(moment("2999-12-31"), "years");
      }),
   dateOfJoining: Yup.string()
      .required("Date of Joining is required")
      .test("is-before-2999", "Date must be before 31-12-2999", function (value) {
         // Parse the date string using Moment.js and check if it's in the past
         const date = moment(value, "YYYY-MM-DD");
         return date.isValid() && date.isBefore(moment("2999-12-31"), "years");
      }),
   dateOfExit: Yup.string()
      .notRequired()
      .test("is-before-2999", "Date must be before 31-12-2999", function (value) {
         // Parse the date string using Moment.js and check if it's in the past
         if (!value) return true;
         const date = moment(value, "YYYY-MM-DD");
         return date.isValid() && date.isBefore(moment("2999-12-31"), "years");
      }),
   aadharNo: Yup.string()
      .required("Aadhar Number is required")
      .matches(/^[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$/, "Invalid aadhar card no!"),
   aadharDocument: Yup.string().required("Aadhar Document is required"),
   panNo: Yup.string().matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, "Invaid pan card no!"),
   helperImage: Yup.string().required("Helper Image is required"),
   address: Yup.string().required("Address is required"),
   payRollType: Yup.string().required("Pay roll type is required"),
   accountNumber: Yup.string().when("payRollType", {
      is: (payRollType) => payRollType === "Oillogistics Pay Roll",
      then: () => validation.accountNumber(),
      otherwise: () => validation.accountNumber(false),
   }),
   bankName: Yup.string().when("payRollType", {
      is: (payRollType) => payRollType === "Oillogistics Pay Roll",
      then: () => validation.bankName(),
      otherwise: () => validation.bankName(false),
   }),
   ifscCode: Yup.string().when("payRollType", {
      is: (payRollType) => payRollType === "Oillogistics Pay Roll",
      then: () => validation.ifscCode(),
      otherwise: () => validation.ifscCode(false),
   }),
   accountHolderName: Yup.string().when("payRollType", {
      is: (payRollType) => payRollType === "Oillogistics Pay Roll",
      then: () => validation.name("account holder name"),
      otherwise: () => validation.name("account holder name", false),
   }),
   monthlySalaryAmount: Yup.string().when("payRollType", {
      is: (payRollType) => payRollType === "Oillogistics Pay Roll",
      then: () => validation.amount("monthly salary amount"),
      otherwise: () => validation.amount("monthly salary amount", false),
   }),
   contractorName: Yup.string().when("payRollType", {
      is: (payRollType) => payRollType === "Contractor",
      then: (schema) => schema.required("Contractor name is required"),
      otherwise: (schema) => schema.notRequired(),
   }),
   monthlySalaryCommissionAmount: Yup.string().when("payRollType", {
      is: (payRollType) => payRollType === "Contractor",
      then: () => validation.amount("monthly salary commission"),
      otherwise: () => validation.amount("monthly salary commission", false),
   }),
});

export default function HelperMasterAdd() {
   const [vehicleDriverName, setVehicleDriverName] = useState("");
   const driverMaster = useSelector((state) => state.driverMaster);
   const contractorsData = driverMaster?.contractors?.map?.((item) => ({
      label: item?.name,
      value: item?.id,
   }));

   // const vendorsData = driverMaster?.singleVehicleMaster?.map?.((item) => ({
   //    label: item?.vehicle_no,
   //    value: item?.id,
   // }));

   const dispatch = useDispatch();
   const navigate = useNavigate();

   const formik = useFormik({
      initialValues: {
         //vehicle_no: "",
         driving_licence: "",
         name: "",
         mobile: "",
         dob: "",
         dateOfJoining: "",
         dateOfExit: "",
         aadharNo: "",
         aadharDocument: "",
         panNo: "",
         panDocument: "",
         helperImage: "",
         address: "",
         payRollType: "Oillogistics Pay Roll",
         accountNumber: "",
         bankName: "",
         ifscCode: "",
         accountHolderName: "",
         monthlySalaryAmount: "",
         contractorName: "",
         monthlySalaryCommissionAmount: "",
      },
      validationSchema: validationSchema,
      onSubmit: (formData) => {
         dispatch(backdropLoadingAction(true));
         const data = {
            //vehicle_no: formData.vehicle_no,
            name: formData.name,
            mobile: formData.mobile,
            dob: formData.dob,
            driving_licence: formData.driving_licence,
            doj: formData.dateOfJoining,
            doe: formData.dateOfExit,
            helper_image: formData.helperImage,
            address: formData.address,
            aadhar_card: formData.aadharNo,
            aadhar_card_doc: formData.aadharDocument,
            pan_card: formData.panNo,
            pan_card_doc: formData.panDocument,
            payroll: formData.payRollType,
            model_id: 5,
            action_id: 1,
         };

         if (data.payroll === "Oillogistics Pay Roll") {
            data.account_number = formData.accountNumber;
            data.bank_name = formData.bankName;
            data.ifsc_code = formData.ifscCode;
            data.account_holder_name = formData.accountHolderName;
            data.monthly_salary_amount = formData.monthlySalaryAmount;
         }

         if (data.payroll === "Contractor") {
            data.contractor_master_id = formData.contractorName;
            data.monthly_salary_commission_amount =
               formData.monthlySalaryCommissionAmount;
            data.helper_account_number = formData.accountNumber;
            data.helper_bank_name = formData.bankName;
            data.helper_ifsc_code = formData.ifscCode;
            data.helper_account_holder_name = formData.accountHolderName;
            data.helper_monthly_salary_amount = formData.monthlySalaryAmount;
         }

         const newData = new FormData();
         Object.keys(data).forEach((key) => {
            newData.append(key, data[key]);
         });

         dispatch(
            addHelperMasterAsync({
               data: newData,
               done: () => {
                  resetForm();
                  dispatch(backdropLoadingAction(false));
                  toast.success("Helper master added successfully.");
                  navigate("/helper-master/view");
               },
               err: () => {
                  dispatch(backdropLoadingAction(false));
                  //toast.error("Something went wrong.");
               },
            }),
         );
      },
   });

   const {
      errors,
      values,
      touched,
      isSubmitting,
      resetForm,
      setFieldValue,
      getFieldProps,
      handleSubmit,
   } = formik;

   // Focus error field
   useFocusErrorField(errors, isSubmitting);

   useEffect(() => {
      dispatch(backdropLoadingAction(true));
      let pendingRequests = 2;
      const handleRequestComplete = () => {
         pendingRequests -= 1;
         if (pendingRequests <= 0) {
            dispatch(backdropLoadingAction(false));
         }
      };

      dispatch(
         fetchAllContractorsAsync({
            done: handleRequestComplete,
            err: handleRequestComplete,
         }),
      );

      dispatch(
         fetchAllFleetAsync({
            done: handleRequestComplete,
            err: handleRequestComplete,
         }),
      );
   }, [dispatch]);

   return (
      <div>
         <BodyHeader title="Add Helper Master" />
         <form className="p-3 shadow-lg" onSubmit={handleSubmit}>
            <div className="row">
               <div className="col-lg-12">
                  <div className="card card-primary">
                     <div className="card-header">
                        <h3 className="card-title">Personal Details</h3>
                     </div>
                     <div className="card-body row">
                        {/* <div className="col-lg-3">
                           <CustomDropdown
                              require
                              label="Vehicle No."
                              name="vehicle_no"
                              id="vehicle_no"
                              optionData={vendorsData}
                              onChange={(values) => {
                                 setFieldValue("vehicle_no", values?.[0]?.value);
                                 if (values?.[0]?.value) {
                                    singleFleetApiCall(values[0].value)
                                       .then(({ data }) => {
                                         // console.log("data", data);
                                          const driverName =
                                             data?.res?.name || "No driver available";
                                          setVehicleDriverName(driverName);
                                       })
                                       .catch(() => {
                                          setVehicleDriverName("No driver available");
                                       });
                                 } else {
                                    setVehicleDriverName("No driver available");
                                 }
                              }}
                              errors={
                                 Boolean(touched.vehicle_no) && Boolean(errors.vehicle_no)
                              }
                              message={errors.vehicle_no}
                           />
                           <p className="mt-2 mb-0 text-muted small">
                              Driver Name: {vehicleDriverName || "No driver available"}
                           </p>
                        </div> */}

                        <div className="col-lg-3">
                           <CustomInput
                              require
                              label="Name"
                              id="driverName"
                              placeholder="Enter Name"
                              {...getFieldProps("name")}
                              errors={touched.name && errors.name}
                              message={errors.name}
                           />
                        </div>
                        <div className="col-lg-3">
                           <CustomInput
                              require
                              label="Mobile No"
                              id="mobile"
                              maxLength={10}
                              placeholder="Enter Mobile No"
                              {...getFieldProps("mobile")}
                              errors={Boolean(touched.mobile) && Boolean(errors.mobile)}
                              message={errors.mobile}
                           />
                        </div>

                        <div className="col-lg-3">
                           <CustomInput
                              label="Driving Licence"
                              placeholder="Driving Licence"
                              {...getFieldProps("driving_licence")}
                              errors={touched.driving_licence && errors.driving_licence}
                              message={errors.driving_licence}
                           />
                        </div>

                        <div className="col-lg-3">
                           <CustomDatePicker
                              require
                              label="DOB"
                              placeholder="Select DOB"
                              {...getFieldProps("dob")}
                              errors={touched.dob && errors.dob}
                              message={errors.dob}
                           />
                        </div>

                        {/* Date of Joining */}
                        <div className="col-lg-3">
                           <CustomDatePicker
                              require
                              label="Date of Joining"
                              placeholder="Select Date of Joining"
                              {...getFieldProps("dateOfJoining")}
                              errors={touched.dateOfJoining && errors.dateOfJoining}
                              message={errors.dateOfJoining}
                           />
                        </div>
                        {/* Date of Exit */}
                        <div className="col-lg-3">
                           <CustomDatePicker
                              label="Date of Exit"
                              placeholder="Select Date of Exit"
                              {...getFieldProps("dateOfExit")}
                              errors={touched.dateOfExit && errors.dateOfExit}
                              message={errors.dateOfExit}
                           />
                        </div>

                        <div className="col-lg-3">
                           <CustomInput
                              require
                              label="Aadhar Card No"
                              id="aadharCard"
                              placeholder="Enter Aadhar Card"
                              {...getFieldProps("aadharNo")}
                              errors={touched.aadharNo && errors.aadharNo}
                              message={errors.aadharNo}
                           />
                        </div>
                        <div className="col-lg-3">
                           <CustomFileUpload
                              require={true}
                              label=" Aadhar Document"
                              {...getFieldProps("aadharDocument")}
                              onChange={(e) => {
                                 setFieldValue("aadharDocument", e.target.files[0]);
                              }}
                              errors={touched.aadharDocument && errors.aadharDocument}
                              message={errors.aadharDocument}
                              accept=".pdf,.png, .jpeg, .jpg"
                           />
                        </div>
                        <div className="col-lg-3">
                           <CustomInput
                              label="Pan Card No"
                              id="panCard"
                              placeholder="Enter Pan Card No"
                              {...getFieldProps("panNo")}
                              errors={touched.panNo && errors.panNo}
                              message={errors.panNo}
                           />
                        </div>
                        <div className="col-lg-3">
                           <CustomFileUpload
                              label="Pan Card Document"
                              {...getFieldProps("panDocument")}
                              onChange={(e) => {
                                 setFieldValue("panDocument", e.target.files[0]);
                              }}
                              errors={touched.panDocument && errors.panDocument}
                              message={errors.panDocument}
                              accept=".pdf,.png, .jpeg, .jpg"
                           />
                        </div>
                        <div className="col-lg-3">
                           <CustomFileUpload
                              label="helper Image"
                              require={true}
                              {...getFieldProps("helperImage")}
                              onChange={(e) => {
                                 setFieldValue("helperImage", e.target.files[0]);
                              }}
                              errors={touched.helperImage && errors.helperImage}
                              message={errors.helperImage}
                              accept=".pdf, .png, .jpeg, .jpg"
                           />
                        </div>
                        <div className="col-lg-12">
                           <CustomTextArea
                              label="Address"
                              id=""
                              placeholder="Enter Address"
                              {...getFieldProps("address")}
                              errors={touched.address && errors.address}
                              message={errors.address}
                           />
                        </div>
                     </div>
                  </div>
               </div>
            </div>

            {/* Tyre Sec */}
            <div className="row">
               <div className="col-lg-12">
                  <div className="card card-primary">
                     <div className="card-header">
                        <h3 className="card-title">Pay roll</h3>
                     </div>

                     <div className="card-body">
                        <div className="form-group">
                           <CustomRadio
                              label="Oil Logistics Pay Roll"
                              id="eisakuPayRoll"
                              value="Oillogistics Pay Roll"
                              name="payRollType"
                              defaultChecked={
                                 values.payRollType === "Oillogistics Pay Roll"
                              }
                              onChange={(event) =>
                                 setFieldValue("payRollType", event.target.value)
                              }
                           />
                           <CustomRadio
                              label="Contractor"
                              id="contractor"
                              value="Contractor"
                              name="payRollType"
                              onChange={(event) =>
                                 setFieldValue("payRollType", event.target.value)
                              }
                           />
                           <CustomRadio
                              label="Self"
                              value="Self"
                              id="self"
                              name="payRollType"
                              checked={values.payRollType === "Self"}
                              onChange={(event) =>
                                 setFieldValue("payRollType", event.target.value)
                              }
                           />
                        </div>
                        {values.payRollType === "Self" && (
                           <div className="row mt-2">
                              <div className="col-12 col-md-6 col-lg-4">
                                 <div className="p-3 border rounded bg-light d-flex align-items-center shadow-sm">
                                    <div className="flex-grow-1">
                                       <label className="form-label text-muted small text-uppercase fw-bold mb-1">
                                          Payment Mode
                                       </label>
                                       <div className="d-flex align-items-center ml-3">
                                          <input
                                             type="checkbox"
                                             className="form-check-input me-2"
                                             checked
                                             readOnly
                                             style={{
                                                width: "1.2rem",
                                                height: "1.2rem",
                                                accentColor: "#0d6efd",
                                                opacity: 1,
                                             }}
                                          />
                                          <span className="fw-bold text-dark fs-5 ml-1 mt-1">
                                             Cash
                                          </span>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        )}
                        {formik.values?.payRollType === "Contractor" && (
                           <div className="row">
                              <div className="col-lg-6">
                                 <CustomDropdown
                                    require
                                    label="Contractor Name"
                                    optionData={contractorsData}
                                    placeholder="Enter contractor Name"
                                    onChange={(values) => {
                                       setFieldValue("contractorName", values[0]?.value);
                                    }}
                                    errors={
                                       touched.contractorName && errors.contractorName
                                    }
                                    message={errors.contractorName}
                                 />
                              </div>
                              <div className="col-lg-6">
                                 <CustomInput
                                    require
                                    label="Monthly Commission Amount"
                                    id="monthlyCommAmount"
                                    placeholder="Enter monthly commission amount"
                                    {...getFieldProps("monthlySalaryCommissionAmount")}
                                    errors={
                                       touched.monthlySalaryCommissionAmount &&
                                       errors.monthlySalaryCommissionAmount
                                    }
                                    message={errors.monthlySalaryCommissionAmount}
                                 />
                              </div>
                           </div>
                        )}
                        {values.payRollType !== "Self" && (
                           <div className="row">
                              <div className="col-lg-4">
                                 <CustomInput
                                    inputType="number"
                                    require={
                                       values.payRollType === "Oillogistics Pay Roll"
                                    }
                                    label="Account Number"
                                    id="AccountNumber"
                                    placeholder="Enter Account Number"
                                    {...getFieldProps("accountNumber")}
                                    errors={touched.accountNumber && errors.accountNumber}
                                    message={errors.accountNumber}
                                 />
                              </div>
                              <div className="col-lg-4">
                                 <CustomInput
                                    require={
                                       values.payRollType === "Oillogistics Pay Roll"
                                    }
                                    label="Bank name"
                                    id="bankName"
                                    placeholder="Enter Bank Name"
                                    {...getFieldProps("bankName")}
                                    errors={touched.bankName && errors.bankName}
                                    message={errors.bankName}
                                 />
                              </div>
                              <div className="col-lg-4">
                                 <CustomInput
                                    require={
                                       values.payRollType === "Oillogistics Pay Roll"
                                    }
                                    label="IFSC Code"
                                    id="ifscCode"
                                    placeholder="Enter IFSC Code"
                                    {...getFieldProps("ifscCode")}
                                    errors={touched.ifscCode && errors.ifscCode}
                                    message={errors.ifscCode}
                                 />
                              </div>

                              <div className="col-lg-4">
                                 <CustomInput
                                    require={
                                       values.payRollType === "Oillogistics Pay Roll"
                                    }
                                    label="Account Holder Name"
                                    id="accountHolderName"
                                    placeholder="Enter Account Holder name"
                                    {...getFieldProps("accountHolderName")}
                                    errors={
                                       touched.accountHolderName &&
                                       errors.accountHolderName
                                    }
                                    message={errors.accountHolderName}
                                 />
                              </div>
                              <div className="col-lg-4">
                                 <CustomInput
                                    inputType="number"
                                    require={
                                       values.payRollType === "Oillogistics Pay Roll"
                                    }
                                    label="Monthly salary amount"
                                    id="monthlyAmount"
                                    placeholder="Enter Monthly salary amount"
                                    {...getFieldProps("monthlySalaryAmount")}
                                    errors={
                                       touched.monthlySalaryAmount &&
                                       errors.monthlySalaryAmount
                                    }
                                    message={errors.monthlySalaryAmount}
                                 />
                              </div>
                           </div>
                        )}
                     </div>
                  </div>
               </div>
               <div className="col-12 mt-3 text-center">
                  <button
                     className="btn btn-primary px-4 py-3"
                     type="submit"
                     onClick={handleSubmit}
                  >
                     <h6 className="mb-0 text-uppercase">Submit</h6>
                  </button>
                  {/* <button className="btn btn-danger ml-3 px-4 py-3" onClick={resetForm}>
                     <h6 className="mb-0 text-uppercase">reset</h6>
                  </button> */}
               </div>
            </div>
         </form>
      </div>
   );
}
